import { useMemo } from "react";
import usePaginatedApiData from "../../../../hooks/usePaginatedApiData";
import { buildPaginationParams } from "../../../../utils/pagination";

export default function useIncubatorsData({
  page,
  pageSize,
  searchTerm,
  pipelineStatus,
  orderBy,
  orderDirection,
}) {
  const params = useMemo(
    () =>
      buildPaginationParams({
        page,
        pageSize,
        search: searchTerm || undefined,
        pipeline_status: pipelineStatus || undefined,
        sort_by: orderBy,
        sort_dir: orderDirection,
      }),
    [page, pageSize, searchTerm, pipelineStatus, orderBy, orderDirection],
  );

  const {
    data: incubators,
    totalCount,
    loading,
    error,
    refetch,
  } = usePaginatedApiData({
    endpoint: "/incubators/",
    params,
    errorMessage: "Failed to load incubators",
  });

  return {
    incubators,
    totalCount,
    loading,
    error,
    refetch,
  };
}
